module.exports = __webpack_public_path__ + "static/media/chess-pawn.d995afae.svg";